module.exports = __webpack_public_path__ + "static/media/movies.692b2266.png";